import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import { MeshoptDecoder } from "three/examples/jsm/libs/meshopt_decoder.module.js";

export async function measureGLB(file) {
  const dracoLoader = new DRACOLoader();
  dracoLoader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.6/");

  const loader = new GLTFLoader();
  loader.setDRACOLoader(dracoLoader);
  loader.setMeshoptDecoder(MeshoptDecoder);

  const arrayBuffer = await file.arrayBuffer();

  const gltf = await new Promise((res, rej) =>
    loader.parse(arrayBuffer, "", res, rej)
  );

  dracoLoader.dispose();

  const scene = gltf.scene.clone(true);

  const box = new THREE.Box3().setFromObject(scene);
  const size = new THREE.Vector3();
  const center = new THREE.Vector3();

  box.getSize(size);
  box.getCenter(center);

  return {
    widthM: size.x,
    heightM: size.y,
    depthM: size.z,
    minY: box.min.y,
    maxY: box.max.y,
    center: { x: center.x, y: center.y, z: center.z },
  };
}
